// Injected at build time by vite.config.ts (define block). Emitted as the
// fixed-name, unhashed assets/build-meta.js so the hashed app chunks stay
// byte-identical for identical sources — inlining the sha or time into main
// would churn the tracked cmd/server/dist/index.html on every commit (#75).
declare const __APP_BUILD_SHA__: string;
declare const __APP_BUILD_TIME__: string;

declare global {
  interface Window {
    __APP_BUILD__?: { sha: string; time: string };
  }
}

window.__APP_BUILD__ = { sha: __APP_BUILD_SHA__, time: __APP_BUILD_TIME__ };

export {};
